import { __extends, __assign, __decorate, __metadata } from 'tslib';
import { Prop, Model, Component, Vue } from 'vue-property-decorator';
import { EnumProp } from '../../utils/enumProp.js';
import { SwitcherIconSize } from './SwitcherIconSize.js';
import __vue_component__ from './HseSwitcherIcon.vue.js';

/**
 * @figma https://www.figma.com/file/cBHD57QcCt9WDT4e7e2B3w/hse_general_library?node-id=2758%3A0
 * @storybook /?path=/story/inputs-switcher--playground
 * @react /src-components-switcher
 * @reactStorybook /?path=/story/inputs-switcher--playground
 * @requires ./HseSwitcherIcon.vue
 */
var HseSwitcher = /** @class */ (function (_super) {
    __extends(HseSwitcher, _super);
    function HseSwitcher() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.focused = false;
        return _this;
    }
    Object.defineProperty(HseSwitcher.prototype, "listeners", {
        get: function () {
            return __assign(__assign({}, this.$listeners), { change: this.onChange, focus: this.onFocus, blur: this.onBlur });
        },
        enumerable: false,
        configurable: true
    });
    HseSwitcher.prototype.onChange = function (e) {
        /**
         * Срабатывает при изменении состояния
         * @type {boolean}
         */
        this.$emit('change', e.target.checked);
    };
    HseSwitcher.prototype.onFocus = function (e) {
        this.focused = e.target.classList.contains('focus-visible');
        /**
         * Срабатывает при фокусе на input
         * @type {FocusEvent}
         */
        this.$emit('focus', e);
    };
    HseSwitcher.prototype.onBlur = function (e) {
        this.focused = false;
        /**
         * Срабатывает при потере фокуса на input
         * @type {FocusEvent}
         */
        this.$emit('blur', e);
    };
    __decorate([
        Prop(EnumProp(SwitcherIconSize.small, SwitcherIconSize)),
        __metadata("design:type", String)
    ], HseSwitcher.prototype, "size", void 0);
    __decorate([
        Model('change'),
        __metadata("design:type", Boolean)
    ], HseSwitcher.prototype, "checked", void 0);
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseSwitcher.prototype, "inactive", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], HseSwitcher.prototype, "label", void 0);
    __decorate([
        Prop({
            default: function () { return ({
                input: '',
                icon: '',
                label: ''
            }); }
        }),
        __metadata("design:type", Object)
    ], HseSwitcher.prototype, "classes", void 0);
    HseSwitcher = __decorate([
        Component({
            name: 'HseSwitcher',
            inheritAttrs: false,
            components: {
                HseSwitcherIcon: __vue_component__
            }
        })
    ], HseSwitcher);
    return HseSwitcher;
}(Vue));

export default HseSwitcher;
